<!-- DeleteVendorServiceModal.vue -->

<template>

  <div class="modal" id="deleteVendorServiceModal" tabindex="-1" aria-labelledby="deleteVendorServiceModalLabel" aria-hidden="true" ref="deleteVendorServiceModal">
    <div class="modal-dialog">

      <div class="modal-content shadow shadow-lg">
        <div class="modal-header border-bottom">
          <h5 class="modal-title">Delete Service</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          Are you sure you want to delete this service?
        </div>

        <div class="modal-footer">
          <span v-if="isDeleting('deletingVendorService')" class="ms-2 spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-danger" @click="deleteRecord" :disabled="isDeleting('deletingVendorService') || isSubmitting">Delete</button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
/* global bootstrap */
import { mapGetters } from 'vuex';

export default {
  name: 'DeleteVendorServiceModal',
  emits: [
    'showAlert',
    'showError',
    'fetchVendorServices',
  ],
  props: {
    vendorServiceId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      modalInstance: null,
    };
  },

  computed: {
    ...mapGetters([
      'allLanguagePairsOptions',
      'allServicesOptions',
      'allUnitsOptions',
      'allSpecialitiesOptions',

      'isCreating',
      'isFetching',
      'isUpdating',
      'isDeleting',
      'getProperty',
    ]),
  },

  watch: { },

  methods: {
    openModal() {
      if (!this.modalInstance) {
        const modalElement = this.$refs.deleteVendorServiceModal;
        this.modalInstance = new bootstrap.Modal(modalElement);
      }
      this.modalInstance.show();
    },

    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },

    async deleteRecord() {
      this.isSubmitting = true;

      try {
        await this.$store.dispatch('deleteRecord', {
          tableName: 'Vendor Services',
          recordId: this.vendorServiceId,
          deletingStateVariable: 'deletingVendorService',
        });

        this.$emit('showAlert', 'success', 'Successfully deleted service');
        this.closeModal();
        this.$emit('fetchVendorServices');

      } catch (error) {
        this.$emit('showAlert', 'danger', 'Error deleting vendor service: ' + error.message);
        console.error('Error deleting vendor service: ', error);

      } finally {
        this.isSubmitting = false;
      }
    },
  },

  async mounted() { },

  created() { },
};
</script>